import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ProfileScreeningCard = ({ cardTitle, icon, iconColor, isError = false, status }) => {
    return (React.createElement(Box, { sx: [{ display: 'flex', flexDirection: 'column', gap: 1 }, isError ? { color: themeColors.accent.red.bold } : {}] },
        React.createElement(Typography, { variant: 'body2' }, cardTitle),
        React.createElement(Box, { sx: { display: 'flex' } },
            React.createElement(Box, { sx: { alignItems: 'center', color: iconColor, display: 'flex' } }, icon),
            React.createElement(Typography, { variant: 'subtitle1', sx: { ml: 2 } }, status))));
};
